   <template>
  <div class="allList"  ref="wrapper">
    <div>
    <div class="listBar">
      <Breadcrumb separator="<b class='demo-breadcrumb-separator'>></b>">
        <BreadcrumbItem  v-for="(item,index) in currentList" :key="index">{{item}}</BreadcrumbItem>  
      </Breadcrumb>
    </div>
       <div style="padding:0.2rem">
          <Checkbox
                :indeterminate="indeterminate"
                :value="checkAll"
                @click.prevent.native="handleCheckAll">{{$t('m.SelectAll')}}</Checkbox>
        </div>
    <div class="departmentList">

      <CheckboxGroup v-model="checkAllGroupList" @on-change="changeList">
        <div class="listName" v-for="(item,index) in  subDepartmentWithUsers" :key="index">
          <Checkbox :label="index">
            <span style="margin-left:0.2rem">{{item.name}}</span>
            <span>({{item.userAllCount}}{{$t('m.SelectZero')}})</span>
          </Checkbox>
          <span class="rightImg" @click="goNextdepartments(item)"><img
              src="../../../assets/images/tx/04.png"
              alt=""
            ></span>
        </div>
      </CheckboxGroup>
    </div>
    <div class="userNameList"
    
        v-for="(item, key) of userDirectList"
        :key="key"
        :ref="key"
     >
      <div class="listTitle">{{key}}</div>
      <div class="item-list">
        <CheckboxGroup  v-model="checkAllGroup" @on-change="change">
          <div class="userInfo" v-for="innerItem of item" :key="innerItem.id">
            <Checkbox :label="innerItem.id">
              <!-- <span><img
                  src="../../../assets/images/tx/04.png"
                  alt=""
                ></span> -->
              <span style="margin-left:0.2rem">{{innerItem.name}}</span>
              <span>{{innerItem.mobile}}</span>
            </Checkbox>
          </div>
        </CheckboxGroup>
      </div>
    </div>
  
    </div>
  </div>

</template>
<script>
import Bscroll from 'better-scroll'
import {getUserByDepartmentId1} from ".../../../src/assets/js/url";

export default {
  data(){
    return{
      list: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R'],
      indeterminate: false,
      checkAll: false,
      checkAllGroup:[],
      checkAllGroupList:[],
      //所有部门数据
      listAll:'',
      currentList:[this.$t('m.CompanyName'),this.$t('m.Connector')],
       //选中的部门头部列表
      listBar:[this.$t('m.Connector'),this.$t('m.CompanyName')],
      departmentInfoAll:'',
     //部门下的详细部门
      departmentInfo:'',
     //二级部门信息
      listinfo:'',
     //二级部门人员信息
      person:'',
      //子部们选择状态的人数
      childrenList:[]
    }
  },
   props: {
    letter: String,
    subDepartments:Array,
    userList:Object,
    isAll:Boolean,
    subDepartmentWithUsers:Array,
    userDirectList:Object
  },
  activated() {
   let storage = window.localStorage;
   this.departmentInfo = JSON.parse(storage.listInfo)
  //  if(this.isAll==="true"){
  //    console.log("this")
  //  }
 
  
   this.getListInfo()
   setTimeout(()=>{
     this.changeAllStatus()
   },500)
  },
  // computed(){
  //   this.changeAllStatus()
  // },
  methods:{
       //第一次进入查看是否为全选
       changeAllStatus(){
         console.log(this.isAll)
        if(this.isAll){
          this.checkAll=true
          let  arr1 = [];
              let  arr2 = [];
              let  arr3 = [];
              for(var  i=0;i<this.subDepartmentWithUsers.length;i++){
                arr1[i]=i
              }
              for(  let   k in this.userDirectList){
                arr2.push(...this.userDirectList[k])
              }
              for(var  i=0;i<arr2.length;i++){
                  arr3[i]=arr2[i].id
              }
              this.checkAllGroup = arr3;
              this.checkAllGroupList = arr1
              this.checkAll=true

               //子部门下面的人员的勾选
                
               //直系下面人员的勾选

            }else{
              this.checkAll=false
              this.checkAllGroup = [];
              this.checkAllGroupList = []
            }
       },
       handleCheckAll () {
         
          if (this.indeterminate) {
              this.checkAll = false;
          } else {
              this.checkAll = !this.checkAll;
          }
          this.indeterminate = false;

          if (this.checkAll) {
              let  arr1 = [];
              let  arr2 = [];
              let  arr3 = [];
              for(var  i=0;i<this.subDepartmentWithUsers.length;i++){
                arr1[i]=i
              }
              for(  let   k in this.userDirectList){
                arr2.push(...this.userDirectList[k])
              }
              for(var  i=0;i<arr2.length;i++){
                  arr3[i]=arr2[i].id
              }
     
              this.checkAllGroup = arr3;
              this.checkAllGroupList = arr1
          } else {
              this.checkAllGroup = [];
              this.checkAllGroupList = []
          }
      },
      goNextdepartments(item){
        console.log(item)
      },
      change(data){
        let list= this.checkAllGroup
        console.log(list);
        console.log(data)
        // if(this.data.length<this.checkAllGroup.length){
        //     this.checkAll = true;
        // }else{
        //   this.checkAll = false;
        // }
      },
      changeList(data){
         console.log(this.isAll)
      },
      //获得该部们下的部门详情
      getListInfo(){
          this.$http
          .post(getUserByDepartmentId1, {
            useruuid: window.sessionStorage.getItem('UUID'),
            departmentId:this.departmentInfo.id,
          })
          .then(
            res => {
               if (res.data.status == 2000) {
                const  data=res.data.data;
                console.log(data)
                //   this.listAll = data;
                // this.listinfo = data.subDepartments
                // this.person = data.userList
               }else{
               
               }
            }
          );
      }
  },
  mounted () {
    this.scroll = new Bscroll(this.$refs.wrapper)
  },
  watch:{
    letter(){
      if(this.letter){
       const element = this.$refs[this.letter][0]
        this.scroll.scrollToElement(element)
      }
    },
    checkAllGroupList(val){
      if(val.length<this.subDepartmentWithUsers.length){
        this.checkAll=false;
      }
      //在这当中我可以拿到子部门所勾选的人数
    },
    checkAllGroup(val){
      //在这当中我可以拿到子部门直系人员所勾选的人数
      let  arr=[]
      for(  let   k in this.userDirectList){
                arr.push(...this.userDirectList[k])
       }
       if(val.length<arr.length){
           this.checkAll=false;
       }
    },

   
  }
}
</script>

<style scoped>
.allList{
  position: absolute;
  left: 0px;
  right: 0px;
  bottom:0.49rem;
  top:1rem;
  overflow: hidden;
}
.listBar{
    margin-top: 0.2rem;
    background-color: #D8D8D8;
    padding: 0.08rem 0.2rem;
  }
  .searchList{
    margin-top: 0.2rem;
    padding-left: 0.2rem;
  }
  .listName{
    padding: 0.3rem 0.2rem;
    border-bottom: 1px solid #F5F5F5;
  }
  .rightImg{
   margin-top: 2px;
   float: right;
   margin-right: 0.2rem;
  }
  .rightImg img{
    height: 0.13rem;
  }
  .userNameList{
    padding: 0rem 0.2rem;
  }
  .userNameList .listTitle{
    background-color: #F4F2F3;
    padding: 0.07rem 0.2rem;
    font-size: 0.15rem;
  }
  .departmentList{
    margin-bottom: 0.2rem;
  }
</style>

    



// WEBPACK FOOTER //
// src/components/content/userlist/list.vue